import React, { Component } from 'react';
import classNames from 'classnames';
import 'styles/About.css';
var ga = window.ga;

class AboutPageThree extends Component {
	constructor(props) {
		super(props);

	}

  componentDidMount() {
    ga('send', 'event', 'About 3 Page', 'Page View');
  }


  handlePrev = () => {
    this.props.hideReact(2);
  }

  gotoContact = () => {
    this.props.hideReact(4);
  }

  // handleNext = () => {
  //   window.dispatchEvent(this.props.events.animPage3, false);
  // }


  render() {
    return (
      <div id="AboutPageThree" className="about-page" ref={(el) => this.el = el} >
        <h1 className="stagger-in">Building impactful digital for the world's biggest brands.</h1>

        <p className="stagger-in">Let's create something awesome that will wow your clients.</p>
   
        <div className="site-btn stagger-in" onClick={this.gotoContact}>Get in Touch</div>
      
        <div className="arrow-container stagger-in">
       
          <div className="arrow left" onClick={this.handlePrev}/>
          {/*<div className="arrow right" onClick={this.handleNext}/>*/}
        </div>
      </div>
    );
  }
}

export default AboutPageThree;


// WEBPACK FOOTER //
// ./src/scripts/containers/AboutPageThree.js